import { APIConnector, Settings } from "../base";

const apiConnector = new APIConnector({ timeout: 30000 });

export default class confirmEmailConfig {
	static get base() {
		return Settings.server + "/confirmEmail";
	}

	static get endpointConfirmEmail() {
		return confirmEmailConfig.base;
	}

	static get APIConnector() {
		return apiConnector;
	}
}



// WEBPACK FOOTER //
// ./src/provider/confirmEmail/confirmEmailConf.js